import apiService from '@/api/apiService';

export const updateAdmin = async (id, formData) => {
    const url = `/api/admin/managers/${id}`;

    const data = {
        name: formData.name,
        email: formData.email,
        ...(formData.password && { password: formData.password })
    };

    return apiService.PUT(url, data);
};
